// @ts-nocheck
import $ from 'jquery';
import DateFormat from 'dateformat';
import RSSIUNK from '../images/RSSI/RSSI_UNK.png';
import RSSI1 from '../images/RSSI/RSSI_1.png';
import RSSI2 from '../images/RSSI/RSSI_2.png';
import RSSI3 from '../images/RSSI/RSSI_3.png';
import RSSI4 from '../images/RSSI/RSSI_4.png';
import RSSI5 from '../images/RSSI/RSSI_5.png';
import BatteryIndicator from '../images/BatteryIndicator.svg';
import DualColorBattery from '../images/DualColorBattery.svg';
import PlugSolid from '../images/PlugSolid.svg';
import UnPlug from '../images/Unplug.svg';
import powerOnGreen from '.././images/powerOnGreen.png';
import powerOffGrey from '../images/powerOffGrey.png';
import NotRunning from '../images/NotRunning.png';
import Running from '../images/Running.png';
import batterycritical from '../images/battery-critical.svg';
import batterylow from '../images/battery-low.svg';
import passed from '../images/passed.png';
import failed from '../images/failed.png';
import aborted from '../images/aborted.png';
import runningtime from '../images/running-time.png';
import Skipped from '../images/Skipped.png';
import questionMark from '../images/questionMark.png';
import powerOrange from '../images/powerOrange.png';
import PowerOffline from '../images/PowerOffline.png';
import batterynormal from '../images/battery-normal.svg';
import off from '../images/off.png';
import dataNotAvailable from '../images/DataNotAvailable.svg';
import lodashfilter from 'lodash/filter';

import DBP0 from '../images/DoorBattPct/0.svg';
import DBP10 from '../images/DoorBattPct/10.svg';
import DBP20 from '../images/DoorBattPct/20.svg';
import DBP30 from '../images/DoorBattPct/30.svg';
import DBP40 from '../images/DoorBattPct/40.svg';
import DBP50 from '../images/DoorBattPct/50.svg';
import DBP60 from '../images/DoorBattPct/60.svg';
import DBP70 from '../images/DoorBattPct/70.svg';
import DBP80 from '../images/DoorBattPct/80.svg';
import DBP90 from '../images/DoorBattPct/90.svg';
import DBP100 from '../images/DoorBattPct/100.svg';


const detailFormatters = {
    OEMTypeFormatter(params) {
        var oemType = '';
        if (params != null && params != undefined) {
            switch (params.toString().toUpperCase().trim()) {
                case "C":
                    oemType = "CAR";
                    break;
                case "D":
                    oemType = "DKN";
                    break;
                case "S":
                    oemType = "SC";
                    break;
                case "T":
                    oemType = "TK";
                    break;
                case "U":
                    oemType = "UNK";
                    break;
                case "CARRIER":
                    oemType = "CAR";
                    break;
                case "DAIKIN":
                    oemType = "DKN";
                    break;
                case "STARCOOL":
                    oemType = "SC";
                    break;
                case "THERMOKING":
                    oemType = "TK";
                    break;
                case "UNKNOWN":
                    oemType = "UNK";
                    break;
            }
        }
        return oemType;
    },
    EventDescriptionFormatters: (params, customerSpecificEventList, eventMasterList) => {
        var eventDesc = '-NA-';
        if (params != null && params != undefined) {
            var reeferOEMTypeCd = params.ReeferOEMTypeCd;
            if (params.EventMasterID != null && params.EventMasterID != "" && params.EventMasterID != "null" && params.EventMasterID != undefined) {
                var eventlist = lodashfilter(customerSpecificEventList, function (item) {
                    return item.EventMasterID === params.EventMasterID;
                });
                var custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;
                var custSpecificEventList = lodashfilter(eventlist, function (item) {
                    return item.CustomerID === custId;
                });
                var finalcustSpecificEventList = lodashfilter(custSpecificEventList, function (item) {
                    return item.OEMType === reeferOEMTypeCd;
                });
                if (finalcustSpecificEventList != null && finalcustSpecificEventList.length) {
                    eventDesc = finalcustSpecificEventList.length > 0 ? finalcustSpecificEventList[0].EventDescription.toString() : "";
                }
                else {
                    var eventDescription = lodashfilter(eventMasterList, function (item) {
                        return item.EventMasterID === params.EventMasterID;
                    });
                    if (eventDescription.length > 0 && eventDescription != null) {                        
                        if (eventDescription[0].OverrideEventDesc != null && eventDescription[0].OverrideEventDesc == true) {
                            if (params.OEParams != null && params.OEParams != "" && params.OEParams.length > 0) {
                                var OperationalEventParams = params.OEParams.trimEnd();
                                if (OperationalEventParams != null && OperationalEventParams != "") {
                                    return eventDescription[0].EventDescription + OperationalEventParams; //WI26438 Operational event not shown properly in Status Grid
                                }
                            }
                        }
                        else {
                            if (eventDescription[0].EventCd == "ATP" || eventDescription[0].EventCd == "UTP") {
                                if (params.CustCd3P != null && params.CustCd3P != "" && params.CustName3P != null && params.CustName3P != "") {
                                    return eventDesc = eventDescription[0].EventDescription + params.CustCd3P + " (" + params.CustName3P + ")";
                                }
                            }

                        }
                        return eventDesc = eventDescription[0].EventDescription;

                    }

                }
            }
            return eventDesc;
        }

        return eventDesc;
    },
    UnitTypesListFormatters: (params, UnitTypesList) => {
        var UnitTypeCdDescription = '-NA-';
        if (params.UnitTypeCd != null && params.UnitTypeCd != "" && params.UnitTypeCd != "null" && params.UnitTypeCd != undefined) {
            var UnitTypeCd = params.UnitTypeCd;

            if (UnitTypeCd != null && UnitTypeCd != "" && UnitTypeCd != 0) {
                var UnitTypeCdId = lodashfilter(UnitTypesList, function (item) {
                    return item.UnitTypeCd === UnitTypeCd;
                });
                if (UnitTypeCdId != null && UnitTypeCdId.length > 0) {
                    UnitTypeCdDescription = UnitTypeCdId[0].ColumnDisplay;
                }
            }
        }

        return UnitTypeCdDescription;
    },
    OEMTypeFormatterDetail(params) {
        var oemType = '';
        if (params != null && params != undefined) {
            switch (params.toString().toUpperCase().trim()) {
                case "C":
                    oemType = "Carrier";
                    break;
                case "D":
                    oemType = "Daikin";
                    break;
                case "S":
                    oemType = "Star Cool";
                    break;
                case "T":
                    oemType = "ThermoKing";
                    break;
                case "U":
                    oemType = "Unknown";
                    break;
                case "CARRIER":
                    oemType = "Carrier";
                    break;
                case "DAIKIN":
                    oemType = "Daikin";
                    break;
                case "STARCOOL":
                    oemType = "Star Cool";
                    break;
                case "THERMOKING":
                    oemType = "ThermoKing";
                    break;
                case "UNKNOWN":
                    oemType = "Unknown";
                    break;
            }
        }
        return oemType;
    },
    DateTypeFormatter(params: any) {
        if (params != null && params != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    RSSIFormatter(params: any) {
        var imagePath = RSSIUNK;
        if (params != null && params != undefined && params != '') {

            if (params == 0)
                imagePath = RSSIUNK;
            else if (params <= -111)
                imagePath = RSSI1;
            else if (params >= -110 && params <= -100)
                imagePath = RSSI2;
            else if (params >= -99 && params <= -88)
                imagePath = RSSI3;
            else if (params >= -87 && params <= -76)
                imagePath = RSSI4;
            else if (params >= -75)
                imagePath = RSSI5;
            else
                imagePath = RSSIUNK;
        }

        return imagePath;
    },
    pwrStateFormatter(params: any) {

        if (params.RCDPowerSourceCd != null && params.RCDPowerSourceCd != undefined) {
            var imagePath = null;
            if (params.RCDPowerSourceCd.toString().toUpperCase().trim() == "B") {
                imagePath = BatteryIndicator;
            }
            else if (params.DeviceConfig.toString().toUpperCase().trim() == "TRUE" && params.RCDPowerSourceCd.toString().toUpperCase().trim() == "A") {

                imagePath = DualColorBattery;
            }
            else {
                imagePath = PlugSolid;
            }
            return imagePath;
        }
        return '';
    },
    gensetSwitchFormatterImg: (params) => {
        if (params != null && params != undefined) {
            var imagePath = null;
            if (params.toString().toUpperCase().trim() == "TRUE")
                imagePath = powerOnGreen;
            else if (params.toString().toUpperCase().trim() == "FALSE")
                imagePath = powerOffGrey;
            return imagePath;
        }
        else
            return '-NA-';
    },
    gensetRunningFormatter: (params) => {
        if (params != null && params != undefined) {
            var imagePath = null;
            if (params.toString().toUpperCase().trim() == "0" || params.toString().toUpperCase().trim() == "FALSE")
                imagePath = NotRunning; //No
            else if (params.toString().toUpperCase().trim() == "1" || params.toString().toUpperCase().trim() == "TRUE")
                imagePath = Running; //Yes            
            return imagePath;
        }
        else
            return '-NA-';
    },
    RcdPowerSourceFormatter(params: any) {
        var rcdPwrSource = '';
        if (params != null && params != undefined && params != '') {
            switch (params.toString().toUpperCase().trim()) {
                case "A":
                    rcdPwrSource = "AC";
                    break;
                case "B":
                    rcdPwrSource = "Battery";
                    break;
            }
        }

        return rcdPwrSource;
    },
    AlarmListFormatter(params) {
        if (params != null && params != undefined && params != '') {
            if (params.toString().endsWith(",")) {
                params = params.slice(0, -1);
            }

            return params;
        }
        else return "";
    },
    TemperatureFormatter(params: any) {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;//"1";
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null) {
            if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else {
                var tempVal = parseFloat(params);
                if (tempUnitCd.toUpperCase() == "F") {
                    tempVal = ((tempVal * 9) / 5) + 32;
                    var param = parseFloat(tempVal.toString());
                    // WI 26666 return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                    return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                        param.toFixed(parseInt(tempRoundingValue)) : param.toFixed(1);
                }
                else
                    //WI 26666 return parseFloat(params.toFixed(parseInt(tempRoundingValue)));
                    return tempRoundingValue > 0 ? params.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                        params.toFixed(parseInt(tempRoundingValue)) : params.toFixed(1);
            }
        }
        else
            return '-NA-';
    },

    TemperatureFormatterForDeviceTemp(params: any) {
            var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;//"1";
            var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

            if (params != null && params != undefined) {
                if (params.DeviceTemp != null && params.DeviceTemp != undefined && params.DeviceTemp != '-NA-') {
                    if (params.DeviceTemp.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                        return "OOR";
                    else {
                        var tempVal = parseFloat(params.DeviceTemp);
                        if ((params.DeviceType != null && params.DeviceType != undefined && params.DeviceType.toString().toUpperCase().trim() == "ST9100")) {
                            //if (tempVal == 0)
                                return '-NA-';
                        }
                        if (tempUnitCd.toUpperCase() == "F") {
                            tempVal = ((tempVal * 9) / 5) + 32;

                            var param = parseFloat(tempVal.toString());
                            return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                        }
                        else
                            return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue)));
                    }
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
    },

    GPSLatitudeFormatter: (params) => {
        if (params != null && params != undefined) {
            var tempRoundingValue = "6";
            if (params.Latitude != null && params.Latitude != undefined && params.Latitude.toString() != "") {
                var lat = parseFloat(params.Latitude.toString());
                var param = parseFloat(lat.toFixed(parseInt(tempRoundingValue)).toString());
                return param;
            }
            else
                return "-NA-"
        }
        else
            return "-NA-";
    },

    GPSLongitudeFormatter: (params) => {
        if (params != null && params != undefined) {
            var tempRoundingValue = "6";
            if (params.Longitude != null && params.Longitude != undefined && params.Longitude.toString() != "") {
                var longitute = parseFloat(params.Longitude.toString());
                var param = parseFloat(longitute.toFixed(parseInt(tempRoundingValue)).toString());
                return param;
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    },

    GPSLatitudeFormatterForReefer: (params) => {
        if (params != null && params != undefined) {
            var tempRoundingValue = "6";
            if (params.GPSLatitude != null && params.GPSLatitude != undefined && params.GPSLatitude.toString() != "") {
                var lat = parseFloat(params.GPSLatitude.toString());
                var param = parseFloat(lat.toFixed(parseInt(tempRoundingValue)).toString());
                return param;
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    },

    GPSLongitudeFormatterForReefer: (params) => {
        if (params != null && params != undefined) {
            var tempRoundingValue = "6";
            if (params.GPSLongitude != null && params.GPSLongitude != undefined && params.GPSLongitude.toString() != "") {
                var longitute = parseFloat(params.GPSLongitude.toString());
                var param = parseFloat(longitute.toFixed(parseInt(tempRoundingValue)).toString());
                return param;
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    },

    TemperatureFormatterForBooking(params: any) {
        var tempRoundingValue = "1";
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        var BookedTemperature = null;
        var TempUnit = null;
        if (params != null) {
            var strlstValues = params.split('@');
            BookedTemperature = strlstValues[0];
            TempUnit = strlstValues[1];
            if (TempUnit.toUpperCase() == "N")
                return "Non-Running";
            else if (TempUnit.toUpperCase() != tempUnitCd.toUpperCase()) {
                if ("F" == tempUnitCd.toUpperCase()) {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = ((tempValue * 9) / 5) + 32;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = (tempValue - 32) * 5 / 9;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
            }
            else
                return BookedTemperature.toString();
        }
        else
            return '-NA-';
    },
    OperatingModeFormatter: (params: any) => {
        var valueString = "";
        if (params != null && params != undefined && params != '') {
            valueString = params.replace('/^\s+/g', '');

            if (valueString.startsWith(",")) {
                valueString = valueString.substring(1, valueString.length);
            }

            if (valueString.endsWith(",")) {
                valueString = valueString.substring(0, valueString.length - 1);
            }

            return valueString;
        }
        return valueString;

    },
    GetTempColumnFormatter() {
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (tempUnitCd.toUpperCase() == "F")
            return "(°F)";
        else
            return "(°C)";
    },
    GetTimeZoneFormatter() {
        var tempZoneCd = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneCd.trim();
        if (tempZoneCd != null && tempZoneCd != "")
            return "(" + tempZoneCd + ")";
    },
    SensorDataFormatter(params: any) {
        if (params != null) {
            if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else
                return params;
        }

        return "-NA-";
    },
    LineFrequencyFormatter(LineFrequency: any, LineFrequencyQualifier: any, ReeferOEMTypeCd: any, ControllerTypeCd: any) {
        if (LineFrequency != null && LineFrequency != undefined) {
            if (ReeferOEMTypeCd.toString().toUpperCase().trim() == "D" && (ControllerTypeCd == 27 || ControllerTypeCd == 28 || ControllerTypeCd == 32)) {
                if (LineFrequencyQualifier != null && (LineFrequencyQualifier == 0 || LineFrequencyQualifier == 1)) {
                    if (LineFrequency.toString().trim() == "-999")
                        return "Unknown";
                    return parseFloat(LineFrequency).toFixed(1).toString();
                }
                else
                if (LineFrequencyQualifier != null && LineFrequencyQualifier == 8) {
                    //var value = params.value;
                    //if(value == 19)
                    return "High";
                }
                else if (LineFrequencyQualifier != null && LineFrequencyQualifier == 9) {
                    //var value = params.value;
                    //if(value == 35)
                    return "Low";
                }
                else
                    return "Unknown";
            }
            else {
                if (LineFrequency != null) {

                    if (LineFrequency.toString().trim() == "-999") 
                        return "OOR";
                    else
                        return LineFrequency;
                }

                return "-NA-";
            }
        }
        else {
            if (LineFrequency != null) {

                if (LineFrequency.toString().trim() == "-999") 
                    return "OOR";
                else
                    return LineFrequency;
            }

            return "-NA-";
        }
    },
    HumiditySetpointFormatter(params: any) {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "0")
                return "Off";
            else if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },    
    YesNoConverter(params: any) {
        if (params != null && params != undefined && params.toString() != '') {
            if (params.toString().toUpperCase().trim() == "0" || params.toString().toUpperCase().trim() == "FALSE") {
                return "No";
            }
            else if (params.toString().toUpperCase().trim() == "1" || params.toString().toUpperCase().trim() == "TRUE") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }

        return "-NA-";
    },
    BooleanConverter(params: any) {
        if (params != null && params != undefined && params.toString() != '') {
            if (params.toString().toUpperCase().trim() == "0" || params.toString().toUpperCase().trim() == "FALSE") {
                return "False";
            }
            else if (params.toString().toUpperCase().trim() == "1" || params.toString().toUpperCase().trim() == "TRUE") {
                return "True";
            }
        }
        return "-NA-";
    },
    GuestReeferModeFormatter(params: any) {
        if (params != null) {
            if (params.toString().toUpperCase().trim() == "TRUE")
                return "Guest";
            else
                return "Standard";
        }
        else
            return '';
    },
    DoorFormatter(params: any) {
        if (params.HasDoorSensor != null && params.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
            if (params.Door1Open != null) {
                if (params.Door1Open.toString().toUpperCase().trim() == "TRUE")
                    return "Open";
                else
                    return "Closed";
            }
            else
                return "Unknown";
        }
        else
            return "No Sensor";
    },
    //RCNG-2227,2228
    DryDoorFormatter(params: any) {
        if (params.HasDoorSensor != null && params.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
            if (params.Door1Open != null) {
                //if (params.Door1Open.toString().toUpperCase().trim() == "TRUE")
                //    return "Open";
                //else
                //    return "Closed";
                switch (params.Door1Open.toString().toUpperCase().trim()) {
                    case "OPN":
                        return "Open";
                    case "CLS":
                        return "Closed";
                    case "DIS":
                        return "Sensor Error"
                    case "UNP":
                        return "No Sensor";
                    case "UNK":
                        return "-NA-";
                }
            }
            else
                return "-NA-";
        }
        else
            return "No Sensor";
    },
    SecondsToTimeConverter(params: any) {
        if (params != null) {
            var val = parseInt(params);
            if (val != 0) {
                var hours = val / 60;
                var minutes = val % 60;
                return parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";
            }
            else
                return val;
        }
        else
            return '-NA-';
    },

    reeferSecondsToTimeConverter(params: any) {

        if (params != null && params.GPSLastLock != null && params.GPSLastLock != undefined) { //RCNG-2691
            var val = parseInt(params.GPSLastLock);
            if (val != 0) {
                //var hours = val / 60;
                //var minutes = val % 60;
                //return parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";

                if (params.DeviceType != null && params.DeviceType != undefined && params.DeviceType.toString().toUpperCase().trim() == "ST9100") {
                    var minutesVal = val / 60;
                    var hours = minutesVal / 60;
                    var minutes = minutesVal % 60;
                    var seconds = val % 60;
                    return  parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":" + parseInt(seconds.toString());
                }
                else {
                    var hours = val / 60;
                    var minutes = val % 60;
                    return  parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";
                }
            }
            else
                return val;
        }
        else
            return '-NA-';
    },

    dryPwrStateFormatter(params: any) {
        if (params != null && params != undefined) {
            var imagePath = null;
            if (params.toString().toUpperCase().trim() == "C") {
                //imagePath = process.env.PUBLIC_URL + "/images/battery-critical.svg";
                imagePath = batterycritical;

            }
            else if (params.toString().toUpperCase().trim() == "L") {

                imagePath = batterylow;
            }
            else {
                imagePath = batterynormal;

            }
            return imagePath;
        }
        return '';
    },
    DryBatteryPctFormatter(params) {        
        if (params != null && params != undefined) {
                var battPct = (Math.round(params / 10.0)) * 10;
                switch (battPct){
                    case 0:
                        return DBP0;
                    case 10:
                        return DBP10;
                    case 20:
                        return DBP20;
                    case 30:
                        return DBP30;
                    case 40:
                        return DBP40;
                    case 50:
                        return DBP50;
                    case 60:
                        return DBP60;
                    case 70:
                        return DBP70;
                    case 80:
                        return DBP80;
                    case 90:
                        return DBP90;
                    case 100:
                        return DBP100;
                }
            }
        return '';
    },
    chassisBatteryStatusFormatter(params: any) {
        if (params != null && params != undefined) {
            var imagePath = null;
            if (params.toString().toUpperCase().trim() == "C") {
                imagePath = batterycritical;
            }
            else if (params.toString().toUpperCase().trim() == "L") {
                imagePath = batterylow;
            }
            else if (params.toString().toUpperCase().trim() == "N") {
                imagePath = batterynormal;
            }
            return imagePath;
        }
        return '';
    },
    SpeedConverter: (params) => {
        if (params != null && params != undefined) {
            var tempRoundingValue = "2";
            var tempVal = parseFloat(params);
            var param = (tempVal / 1.609344);
            return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
        }
        else
            return '-NA-';
    },
    Current3PhaseFormatter(params: any) {
        var currentValue1 = "";
        var currentValue2 = "";
        var currentValue3 = "";
        if (params != null) {
            var phases = params.split(",");
            if (phases[0].toString().trim() == "-999")
                currentValue1 = "OOR";
            else
                currentValue1 = phases[0].toString().trim();
            if (phases[1].toString().trim() == "-999")
                currentValue2 = "OOR";
            else
                currentValue2 = phases[1].toString().trim();
            if (phases[2].toString().trim() == "-999")
                currentValue3 = "OOR";
            else
                currentValue3 = phases[2].toString().trim();

            return currentValue1 + ", " + currentValue2 + ", " + currentValue3;
        }
        else
            return "";
    },
    StringFormater(params: any) {
        if (params != null && params != undefined && params.toString() != '') {
            return params;
        }
        return "-NA-";
    },
    preTripFormatter(params: any) {
        var imagePath;
        if (params != null && params != undefined && params != '') {
            switch (params.toString().trim()) {
                case 'Passed':
                case 'OK':
                    imagePath = passed;
                    break;
                case 'Failed':
                case 'NG':
                    imagePath = failed;
                    break;
                case 'Aborted':
                    imagePath = aborted;
                    break;
                case 'Running':
                    imagePath = runningtime;
                    break;
                case 'Skipped':
                    imagePath = Skipped;
                    break;
                case 'Unknown':
                    imagePath = questionMark;
                    break;
            }
        }
        return imagePath;
    },
    gensetSwitchFormatter(params) {
        if (params != null && params != undefined) {
            if (params.toString().toUpperCase().trim() == "TRUE")
                return "On";
            else
                return "Off";
        }
        else
            return '-NA-';
    },
    YesNoFormatter(params) {
        if (params != null && params != undefined && params.toString() != '') {
            if (params.toString().toUpperCase().trim() == "0" || params.toString().toUpperCase().trim() == "FALSE") {
                return "No";
            }
            else if (params.toString().toUpperCase().trim() == "1" || params.toString().toUpperCase().trim() == "TRUE") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },
    YearFromdateTypeFormatter: (params) => {
        if (params != null && params != undefined) {
            var eventdttm = new Date(params.toString());
            return eventdttm.getFullYear();
        }
        else
            return '-NA-';
    },
    FloatFormatter(params: any) {
        if (params != null && params != undefined) {
            return params;
        }
        return "-NA-";
    },
    GPSHDOPFormatter(GPSHDOP: any, GPSLockState: any) {
        if (GPSHDOP != null && GPSHDOP != undefined) {
            if (GPSHDOP == "null" || GPSLockState == null || GPSLockState == '' || GPSLockState == "UNLOCKED")
                return '-NA-';
            else
            {
                var decimalPlaces = 2;
                var multiplier = Math.pow(10, decimalPlaces);
                return (Math.round(GPSHDOP * multiplier) / multiplier).toFixed(decimalPlaces);
            }
        }
        else
            return "-NA-";
    },
    GPSSatCountFloatFormatter(GPSSatelliteCount: any, GPSLockState: any) {
        if (GPSSatelliteCount != null && GPSSatelliteCount != undefined) {
            if (GPSSatelliteCount == "null" || GPSLockState == null || GPSLockState == '' || GPSLockState == "UNLOCKED")
                return '-NA-';
            else
                return GPSSatelliteCount;
        }
        else
            return "-NA-";
    },
    GPSFloatFormatter(params: any) {
        if (params != null && params != undefined && params != 0) {
            return params;
        }
        return "-NA-";
    },
    fillLevelGalTrace: (params) => {
        if (params.HasFuelSensor != null && params.HasFuelSensor != undefined
            && params.HasFuelSensor === false) {
            return "No Sensor";
        }
        else {
            if (params != null && params != undefined && params != '') {
                var tempRoundingValue = "2";
                if (params.FuelLevelQualifier != null && ((params.FuelLevelQualifier == 'A') || (params.FuelLevelQualifier == 'P'))) {
                    return (params.FuelLevel != null) ? parseFloat(params.FuelLevel.toFixed(parseInt(tempRoundingValue))) : "-NA-";
                }
                else {
                    return params.FuelLevelQualifierDesc;
                }
            }
            return '-NA-';
        }
    },
    BattVoltageFormatter: (params) => {
        if (params != null && params != undefined) {
            var tempRoundingValue = "1";
            return (params != null) ? parseFloat(params.toFixed(parseInt(tempRoundingValue))) : "-NA-";
        }
        else
            return '-NA-';
    },
    fillLevelTrace: (params) => {
        if (params.HasFuelSensor != null && params.HasFuelSensor != undefined
            && params.HasFuelSensor === false) {
            return "No Sensor";
        }
        else {
            if (params != null && params != undefined && params != '') {
                if (params.HasFuelSensor != null && params.HasFuelSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.FuelLevelQualifier != null && ((params.FuelLevelQualifier == 'A') || (params.FuelLevelQualifier == 'P'))) {
                        if (params.FuelLevelTierNumber != null) {
                            return process.env.PUBLIC_URL + "/images/FuelGaugeFractionImages/" + params.FractionDisplayGif;
                        }
                        else {
                            if (params.FuelLevelPct != null) {
                                var tempRoundingValue = "2";
                                return parseFloat(params.FuelLevelPct.toFixed(parseInt(tempRoundingValue))) + " %";
                            }
                            else {
                                return "FRU";
                            }
                        }
                    }
                    else {
                        if (params.FuelLevelQualifier == "S")
                            return "FSE";
                        else
                            return params.FuelLevelQualifierDesc;
                    }
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
    },
    AlertDescriptionFormatter: (params, alertsList) => {
        var element = "";
        if (params != null && params != undefined) {
            var lstAlerts = params.split(',');
            $.each(lstAlerts, function (index, item) {
                if (item != "" && item != null) {
                    if (alertsList != null && alertsList != undefined && alertsList.length > 0) {
                        var alertDescription = alertsList.filter(e =>
                            e.AlertCD === item.toString().trim());
                        var anchorElement = alertDescription.length > 0 ? alertDescription[0].AlertDsc.toString() : "";
                        if (element != "")
                            element = element + ", " + anchorElement;
                        else
                            element = anchorElement;
                    }
                }
            });
            return element;
        }

        else return "-NA-";
    },
    pwrStateFormatterChassis: (params) => {
        if (params!= null && params != undefined) {
            var imagePath = null;
            if (params.toString().toUpperCase().trim() == "B") {
                imagePath = UnPlug;
            }
            else if(params.toString().toUpperCase().trim() == "A") {
                imagePath = PlugSolid;
            }
            return imagePath;
        }
        return '';
    },
    LoadedFormatter: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().toUpperCase().trim() == "TRUE")
                return "Loaded";
            else
                return "Empty";
        }
        else
            return '-NA-';
    },   
    BrakeSignalFormatter: (params) => {

        return "-NA-";
    },
    DoorFormatterChassis: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.HasDoorSensor != null && params.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.Door1OpenChassis != null) {
                    if (params.Door1OpenChassis.toString().toUpperCase().trim() == "TRUE")
                        return "Open";
                    else
                        return "Closed";
                }
                else
                    return "Unknown";
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },    
    runStateFormatter: (params) => {
        if (params != null && params != undefined) {
            var imagePath = null;
            if ((params.toString().toUpperCase().trim()) == 'I')
                return imagePath = powerOnGreen;

            else if ((params.toString().toUpperCase().trim()) == 'S')
                return imagePath = powerOffGrey;

            else if ((params.toString().toUpperCase().trim()) == 'X')
                return imagePath = powerOrange;

            else if ((params.toString().toUpperCase().trim()) == 'O')
                return imagePath = PowerOffline;

            else
                return '-NA-';
        }

        return '-NA-';
    },
    ModelNumberFormatter(params: any) {
        if (params != null && params != undefined) {
                if (params.ModelNumber != null && params.ModelNumber != '') {//RCNG-3024
                    return params.ModelNumber;//RCNG-3024
                }
                else
                    return "-NA-";
        }
        else
            return "-NA-";
    },
    tripWISEStatusFormatter(params: any) {
        var imagePath;
        if (params != null && params != undefined && params != '') {
            switch (params.toString().trim()) {
                case 'Off':
                    imagePath = off;
                    break;
                case 'Expired':
                    imagePath = aborted;
                    break;
                case 'Check':
                    imagePath = failed;
                    break;
                case 'Passed':
                    imagePath = passed;
                    break;
                case 'Running':
                    imagePath = runningtime;
                    break;
                case 'Unknown':
                    imagePath = questionMark;
                    break;                
                case 'Data Not Available':
                    imagePath = dataNotAvailable;
                    break;
            }
        }
        return imagePath;
    },
}

export default detailFormatters;